import { Variant } from "../../types/types";

export const isOutlet = (variant: Variant) => !!variant.returnsOutlet;
